// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface IDriverAttributeType {
    id: number;
    driverAttributeCategoryType: any;
    driverAttributeValue: string;
    displayValue: string;
    description: string;
    isPhysicalAddress: boolean;
    isAllowDescription: boolean;
    isCredentialPermitRestriction: boolean;
    credentialPriority: number;
    sortOrder: number;
    active: boolean;
    driverAttributeAccessTypeId: number;
}

export class DriverAttributeType implements IDriverAttributeType, IBaseType {
    public id: number;
    public driverAttributeCategoryType: any;
    public driverAttributeValue: string;
    public displayValue: string;
    public description: string;
    public isPhysicalAddress: boolean;
    public isAllowDescription: boolean;
    public isCredentialPermitRestriction: boolean;
    public credentialPriority: number;
    public sortOrder: number;
    public active: boolean;
    public driverAttributeAccessTypeId: number;

    /**
        Returns Passenger DriverAttributeType
    **/
    get Passenger(): IDriverAttributeType {
        return this.FromId(1);
    }
    /**
        Returns Non-CMV Automatic Transmission DriverAttributeType
    **/
    get NonCMVAutomaticTransmission(): IDriverAttributeType {
        return this.FromId(25);
    }
    /**
        Returns Voluntary Travel DriverAttributeType
    **/
    get VoluntaryTravel(): IDriverAttributeType {
        return this.FromId(45);
    }
    /**
        Returns Restricted License DriverAttributeType
    **/
    get RestrictedLicense(): IDriverAttributeType {
        return this.FromId(52);
    }
    /**
        Returns Class G Restrictions DriverAttributeType
    **/
    get ClassGRestrictions(): IDriverAttributeType {
        return this.FromId(54);
    }
    /**
        Returns School Bus DriverAttributeType
    **/
    get SchoolBus(): IDriverAttributeType {
        return this.FromId(2);
    }
    /**
        Returns Corrective lenses DriverAttributeType
    **/
    get Correctivelenses(): IDriverAttributeType {
        return this.FromId(15);
    }
    /**
        Returns Veteran DriverAttributeType
    **/
    get Veteran(): IDriverAttributeType {
        return this.FromId(46);
    }
    /**
        Returns Native American DriverAttributeType
    **/
    get NativeAmerican(): IDriverAttributeType {
        return this.FromId(57);
    }
    /**
        Returns Tank DriverAttributeType
    **/
    get Tank(): IDriverAttributeType {
        return this.FromId(3);
    }
    /**
        Returns Mechanical Aid DriverAttributeType
    **/
    get MechanicalAid(): IDriverAttributeType {
        return this.FromId(16);
    }
    /**
        Returns Organ Donor DriverAttributeType
    **/
    get OrganDonor(): IDriverAttributeType {
        return this.FromId(47);
    }
    /**
        Returns Hazardous Material DriverAttributeType
    **/
    get HazardousMaterial(): IDriverAttributeType {
        return this.FromId(4);
    }
    /**
        Returns Prosthetic Aid DriverAttributeType
    **/
    get ProstheticAid(): IDriverAttributeType {
        return this.FromId(17);
    }
    /**
        Returns Limited Term DriverAttributeType
    **/
    get LimitedTerm(): IDriverAttributeType {
        return this.FromId(48);
    }
    /**
		Returns Double/Triple DriverAttributeType
    **/
    get DoubleTriple(): IDriverAttributeType {
        return this.FromId(5);
    }
    /**
        Returns No Manual Transmission Equipped CMV DriverAttributeType
    **/
    get NoManualTransmissionEquippedCMV(): IDriverAttributeType {
        return this.FromId(26);
    }
    /**
        Returns Emancipated Minor DriverAttributeType
    **/
    get EmancipatedMinor(): IDriverAttributeType {
        return this.FromId(49);
    }
    /**
		Returns Combination Tank/Hazmat DriverAttributeType
    **/
    get CombinationTankHazmat(): IDriverAttributeType {
        return this.FromId(6);
    }
    /**
        Returns Outside Mirror DriverAttributeType
    **/
    get OutsideMirror(): IDriverAttributeType {
        return this.FromId(18);
    }
    /**
        Returns IID Internal DriverAttributeType
    **/
    get IIDInternal(): IDriverAttributeType {
        return this.FromId(50);
    }
    /**
		Returns Motorcycle DriverAttributeType
    **/
    get Motorcycle(): IDriverAttributeType {
        return this.FromId(7);
    }
    /**
        Returns Limited to Daylight Only DriverAttributeType
    **/
    get LimitedtoDaylightOnly(): IDriverAttributeType {
        return this.FromId(19);
    }
    /**
        Returns SIIRDL DriverAttributeType
    **/
    get SIIRDL(): IDriverAttributeType {
        return this.FromId(51);
    }
    /**
        Returns Limited to Employment DriverAttributeType
    **/
    get LimitedtoEmployment(): IDriverAttributeType {
        return this.FromId(20);
    }
    /**
        Returns Limited Other DriverAttributeType
    **/
    get LimitedOther(): IDriverAttributeType {
        return this.FromId(21);
    }
    /**
        Returns Other DriverAttributeType
    **/
    get Other(): IDriverAttributeType {
        return this.FromId(22);
    }
    /**
        Returns IID External DriverAttributeType
    **/
    get IIDExternal(): IDriverAttributeType {
        return this.FromId(53);
    }
    /**
        Returns Intrastate Only DriverAttributeType
    **/
    get IntrastateOnly(): IDriverAttributeType {
        return this.FromId(27);
    }
    /**
		Returns Non-Air Brakes vehicles DriverAttributeType
    **/
    get NonAirBrakesvehicles(): IDriverAttributeType {
        return this.FromId(28);
    }
    /**
        Returns No Class A Passenger Vehicle DriverAttributeType
    **/
    get NoClassAPassengerVehicle(): IDriverAttributeType {
        return this.FromId(29);
    }
    /**
        Returns No Class A and B Passenger Vehicle DriverAttributeType
    **/
    get NoClassAandBPassengerVehicle(): IDriverAttributeType {
        return this.FromId(30);
    }
    /**
        Returns No Tractor-Trailer CMV DriverAttributeType
    **/
    get NoTractorTrailerCMV(): IDriverAttributeType {
        return this.FromId(31);
    }
    /**
        Returns No Passenger in CMV Bus DriverAttributeType
    **/
    get NoPassengerinCMVBus(): IDriverAttributeType {
        return this.FromId(32);
    }
    /**
        Returns Non Domicile CDL DriverAttributeType
    **/
    get NonDomicileCDL(): IDriverAttributeType {
        return this.FromId(33);
    }
    /**
        Returns Restricted Instruction Permit DriverAttributeType
    **/
    get RestrictedInstructionPermit(): IDriverAttributeType {
        return this.FromId(34);
    }
    /**
        Returns Hearing Aid DriverAttributeType
    **/
    get HearingAid(): IDriverAttributeType {
        return this.FromId(23);
    }
    /**
        Returns Golf Cart Only DriverAttributeType
    **/
    get GolfCartOnly(): IDriverAttributeType {
        return this.FromId(35);
    }
    /**
        Returns Medical Variance DriverAttributeType
    **/
    get MedicalVariance(): IDriverAttributeType {
        return this.FromId(37);
    }
    /**
        Returns Farm Waiver DriverAttributeType
    **/
    get FarmWaiver(): IDriverAttributeType {
        return this.FromId(38);
    }
    /**
        Returns No cargo in CMV Tank Vehicle DriverAttributeType
    **/
    get NocargoinCMVTankVehicle(): IDriverAttributeType {
        return this.FromId(39);
    }
    /**
        Returns Instruction Permit DriverAttributeType
    **/
    get InstructionPermit(): IDriverAttributeType {
        return this.FromId(40);
    }
    /**
        Returns No Full Air Brake Equipped CMV DriverAttributeType
    **/
    get NoFullAirBrakeEquippedCMV(): IDriverAttributeType {
        return this.FromId(41);
    }
    /**
        Returns Moped/Motorized Cart DriverAttributeType
    **/
    get MopedMotorizedCart(): IDriverAttributeType {
        return this.FromId(42);
    }
    /**
        Returns Motorcycle 100 cc or less DriverAttributeType
    **/
    get Motorcycle100ccorless(): IDriverAttributeType {
        return this.FromId(43);
    }
    /**
        Returns Three Wheel Cycle DriverAttributeType
    **/
    get ThreeWheelCycle(): IDriverAttributeType {
        return this.FromId(44);
    }
    /**
        Returns Right left side mirrors DriverAttributeType
    **/
    get Rightleftsidemirrors(): IDriverAttributeType {
        return this.FromId(24);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, driverAttributeCategoryType: 1, driverAttributeValue: 'P', displayValue: 'Passenger', description: 'Passenger', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 2, sortOrder: 1, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('25', { id: 25, driverAttributeCategoryType: 3, driverAttributeValue: 'A', displayValue: 'Non-CMV Automatic Transmission', description: 'Non-CMV Automatic Transmission (also automated - medical)', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 7, sortOrder: 1, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('45', { id: 45, driverAttributeCategoryType: 4, driverAttributeValue: 'T', displayValue: 'Voluntary Travel', description: 'Voluntary Travel', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 1, sortOrder: 1, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('52', { id: 52, driverAttributeCategoryType: 3, driverAttributeValue: 'B', displayValue: 'Restricted License', description: 'Restriced License Issued', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 8, sortOrder: 1, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('54', { id: 54, driverAttributeCategoryType: 3, driverAttributeValue: '6', displayValue: 'Class G Restrictions', description: 'Class G Restrictions - 6 Month Probation Period ', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 20, sortOrder: 1, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('2', { id: 2, driverAttributeCategoryType: 1, driverAttributeValue: 'S', displayValue: 'School Bus', description: 'School Bus', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 3, sortOrder: 2, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('15', { id: 15, driverAttributeCategoryType: 2, driverAttributeValue: 'B', displayValue: 'Corrective lenses', description: 'Corrective lenses (also automated - vision screening)', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 12, sortOrder: 2, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('46', { id: 46, driverAttributeCategoryType: 4, driverAttributeValue: 'V', displayValue: 'Veteran', description: 'Veteran', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 2, sortOrder: 2, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('57', { id: 57, driverAttributeCategoryTypeId: 4, driverAttributeValue: 'N', displayValue: 'Native American', description: 'Native American', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 2, sortOrder: 2, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('3', { id: 3, driverAttributeCategoryType: 1, driverAttributeValue: 'N', displayValue: 'Tank', description: 'Tank', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 6, sortOrder: 3, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('16', { id: 16, driverAttributeCategoryType: 2, driverAttributeValue: 'C', displayValue: 'Mechanical Aid', description: 'Mechanical Aid (also automated - medical)', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 13, sortOrder: 3, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('47', { id: 47, driverAttributeCategoryType: 4, driverAttributeValue: 'O', displayValue: 'Organ Donor', description: 'Organ Donor', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 5, sortOrder: 3, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('4', { id: 4, driverAttributeCategoryType: 1, driverAttributeValue: 'H', displayValue: 'Hazardous Material', description: 'Hazardous Material', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 7, sortOrder: 4, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('17', { id: 17, driverAttributeCategoryType: 2, driverAttributeValue: 'D', displayValue: 'Prosthetic Aid', description: 'Prosthetic Aid', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 14, sortOrder: 4, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('48', { id: 48, driverAttributeCategoryType: 4, driverAttributeValue: 'L', displayValue: 'Limited Term', description: 'Limited - Term', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 2, sortOrder: 4, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('5', { id: 5, driverAttributeCategoryType: 1, driverAttributeValue: 'T', displayValue: 'Double/Triple', description: 'Double/Triple', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 4, sortOrder: 5, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('26', { id: 26, driverAttributeCategoryType: 3, driverAttributeValue: 'E', displayValue: 'No Manual Transmission Equipped CMV', description: 'No Manual Transmission Equipped CMV (CDL Only)', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 5, sortOrder: 5, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('49', { id: 49, driverAttributeCategoryType: 4, driverAttributeValue: 'E', displayValue: 'Emancipated Minor', description: 'Emancipated Minor', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 3, sortOrder: 5, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('6', { id: 6, driverAttributeCategoryType: 1, driverAttributeValue: 'X', displayValue: 'Combination Tank/Hazmat', description: 'Combination Tank/Hazmat', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 5, sortOrder: 6, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('18', { id: 18, driverAttributeCategoryType: 2, driverAttributeValue: 'F', displayValue: 'Outside Mirror', description: 'Outside Mirror', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 16, sortOrder: 6, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('50', { id: 50, driverAttributeCategoryType: 4, driverAttributeValue: 'I', displayValue: 'IID Internal', description: 'Ignition Interlock Device Required', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 4, sortOrder: 6, active: true, driverAttributeAccessTypeId: 3 });
        this._dictionary.add('7', { id: 7, driverAttributeCategoryType: 1, driverAttributeValue: 'L', displayValue: 'Motorcycle', description: 'Motorcycle', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 1, sortOrder: 7, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('19', { id: 19, driverAttributeCategoryType: 2, driverAttributeValue: 'G', displayValue: 'Limited to Daylight Only', description: 'Limited to Daylight Only (also automated - vision screening)', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 18, sortOrder: 7, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('51', { id: 51, driverAttributeCategoryType: 3, driverAttributeValue: 'S', displayValue: 'SIIRDL', description: 'Special Ignition Interlock Restricted Driver License', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 6, sortOrder: 7, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('20', { id: 20, driverAttributeCategoryType: 2, driverAttributeValue: 'H', displayValue: 'Limited to Employment', description: 'Limited to Employment', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 19, sortOrder: 8, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('21', { id: 21, driverAttributeCategoryType: 2, driverAttributeValue: 'I', displayValue: 'Limited Other', description: 'Limited Other', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 20, sortOrder: 9, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('22', { id: 22, driverAttributeCategoryType: 2, driverAttributeValue: 'J', displayValue: 'Other', description: 'Other (manually set due to OIG direction to alert LE. This does not appear on a DL but does trigger an alert to LE upon inquiry.) - OIG user or higher', isPhysicalAddress: false, isAllowDescription: true, isCredentialPermitRestriction: false, credentialPriority: 999, sortOrder: 10, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('53', { id: 53, driverAttributeCategoryType: 3, driverAttributeValue: 'T', displayValue: 'IID External', description: 'Ignition Interlock Device', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 2, sortOrder: 10, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('27', { id: 27, driverAttributeCategoryType: 3, driverAttributeValue: 'K', displayValue: 'Intrastate Only', description: 'Intrastate Only', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: true, credentialPriority: 2, sortOrder: 11, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('28', { id: 28, driverAttributeCategoryType: 3, driverAttributeValue: 'L', displayValue: 'Non-Air Brakes vehicles', description: 'Non-Air Brakes vehicles', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 3, sortOrder: 12, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('29', { id: 29, driverAttributeCategoryType: 3, driverAttributeValue: 'M', displayValue: 'No Class A Passenger Vehicle', description: 'No Class A Passenger Vehicle', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 22, sortOrder: 13, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('30', { id: 30, driverAttributeCategoryType: 3, driverAttributeValue: 'N', displayValue: 'No Class A and B Passenger Vehicle', description: 'No Class A and B Passenger Vehicle', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 23, sortOrder: 14, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('31', { id: 31, driverAttributeCategoryType: 3, driverAttributeValue: 'O', displayValue: 'No Tractor-Trailer CMV', description: 'No Tractor-Trailer CMV', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 21, sortOrder: 15, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('32', { id: 32, driverAttributeCategoryType: 3, driverAttributeValue: 'P', displayValue: 'No Passenger in CMV Bus', description: 'No Passenger in CMV Bus', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: true, credentialPriority: 24, sortOrder: 16, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('33', { id: 33, driverAttributeCategoryType: 3, driverAttributeValue: 'Q', displayValue: 'Non Domicile CDL', description: 'Non Domicile CDL', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 6, sortOrder: 17, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('34', { id: 34, driverAttributeCategoryType: 3, driverAttributeValue: 'R', displayValue: 'Restricted Instruction Permit', description: 'Restricted Instruction Permit', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: true, credentialPriority: 999, sortOrder: 18, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('23', { id: 23, driverAttributeCategoryType: 2, driverAttributeValue: 'S', displayValue: 'Hearing Aid', description: 'Hearing Aid', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 15, sortOrder: 19, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('35', { id: 35, driverAttributeCategoryType: 2, driverAttributeValue: 'T', displayValue: 'Golf Cart Only', description: 'Golf Cart Only', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 8, sortOrder: 20, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('37', { id: 37, driverAttributeCategoryType: 3, driverAttributeValue: 'V', displayValue: 'Medical Variance', description: 'Medical Variance', isPhysicalAddress: false, isAllowDescription: true, isCredentialPermitRestriction: false, credentialPriority: 1, sortOrder: 22, active: true, driverAttributeAccessTypeId: 2 });
        this._dictionary.add('38', { id: 38, driverAttributeCategoryType: 3, driverAttributeValue: 'W', displayValue: 'Farm Waiver', description: 'Farm Waiver', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 26, sortOrder: 23, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('39', { id: 39, driverAttributeCategoryType: 3, driverAttributeValue: 'X', displayValue: 'No cargo in CMV Tank Vehicle', description: 'No cargo in CMV Tank Vehicle', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: true, credentialPriority: 25, sortOrder: 24, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('40', { id: 40, driverAttributeCategoryType: 3, driverAttributeValue: 'Y', displayValue: 'Instruction Permit', description: 'Instruction Permit', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: true, credentialPriority: 999, sortOrder: 25, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('41', { id: 41, driverAttributeCategoryType: 3, driverAttributeValue: 'Z', displayValue: 'No Full Air Brake Equipped CMV', description: 'No Full Air Brake Equipped CMV', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 4, sortOrder: 26, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('42', { id: 42, driverAttributeCategoryType: 3, driverAttributeValue: '1', displayValue: 'Moped/Motorized Cart', description: 'Moped/Motorized Cart', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 9, sortOrder: 27, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('43', { id: 43, driverAttributeCategoryType: 3, driverAttributeValue: '2', displayValue: 'Motorcycle 100 cc or less', description: 'Motorcycle 100 cc or less', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 10, sortOrder: 28, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('44', { id: 44, driverAttributeCategoryType: 3, driverAttributeValue: '3', displayValue: 'Three Wheel Cycle', description: 'Three Wheel Cycle', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 11, sortOrder: 29, active: true, driverAttributeAccessTypeId: 1 });
        this._dictionary.add('24', { id: 24, driverAttributeCategoryType: 2, driverAttributeValue: '4', displayValue: 'Right left side mirrors', description: 'Right left side mirrors', isPhysicalAddress: false, isAllowDescription: false, isCredentialPermitRestriction: false, credentialPriority: 17, sortOrder: 30, active: true, driverAttributeAccessTypeId: 2 });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): IDriverAttributeType {
        return this._dictionary[id];
    }

    public FromDisplayValue(displayValue: string): IDriverAttributeType {
        var match = this._dictionary.getValues().filter(d => d.value == displayValue);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): IDriverAttributeType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): IDriverAttributeType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): IDriverAttributeType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
